export default {"src":"/_next/static/media/logo-institut-francais-white.a0ad5e59.svg","height":131,"width":214};